// extracted by mini-css-extract-plugin
module.exports = {"loadingAnimation":"loadingSkeleton_loadingAnimation__2tn4z","loadingColor":"loadingSkeleton_loadingColor__RkOGi"};